import { format } from 'bytes';
import { useAsObservableSource, useLocalStore } from 'mobx-react-lite';

import {
  IFileDownloadStatePresenter,
  useFileDownloadStatePresenter,
} from 'APP/hooks/useFileDownloadState/useFileDownloadState';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';
import { FilePayload } from 'STORE/Messages/Message/Payload/FilePayload/FilePayload';

interface IFilePresenter {
  message: ChatMessage & { messageId: string };
}

export interface IFileLocalStore {
  formattedBytes: string;
}

export const useFilePresenter = ({
  message,
}: IFilePresenter): {
  presenter: IFileLocalStore;
  fileDownloadPresenter: IFileDownloadStatePresenter;
} => {
  const fileDownloadPresenter = useFileDownloadStatePresenter({
    groupId: message.groupId,
    messageId: message.messageId || message.id,
    payloadId: message.payload?.id || message.id,
  });

  const source = useAsObservableSource({ message, fileDownloadPresenter });

  const presenter = useLocalStore<IFileLocalStore>(() => ({
    get formattedBytes(): string {
      const { fileSize } = source.message.payload as FilePayload;
      const formattedSize = format(fileSize, { unitSeparator: ' ', decimalPlaces: 2 });
      const formattedLoadedBytes = format(source.fileDownloadPresenter.loaded, {
        unitSeparator: ' ',
        decimalPlaces: 2,
        fixedDecimals: true,
      });

      return source.fileDownloadPresenter.isDownloadInProcess
        ? `${formattedLoadedBytes} / ${formattedSize}`
        : formattedSize || '';
    },
  }));

  return { presenter, fileDownloadPresenter };
};
